import { PjmLocationReductionInfo } from './dto/PjmLocationReductionInfo';

export function calcMaxLoadReductionCapability(reductionInfo: PjmLocationReductionInfo[]): number {
    const loadReduction = reductionInfo.reduce((prev: number, cur) => {
        prev = prev + (cur.reductionValue ?? 0);
        return prev;
    }, 0);

    return loadReduction;
}
